import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-24 px-6 lg:px-12 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/c9eedcc3a537072c72c458e76e20659a.jpg)',
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-slate-900/90 to-cyan-900/95"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-8 border border-white/20">
          <i className="ri-mail-line text-white"></i>
          <span className="text-sm text-white font-semibold">Get Started Today</span>
        </div>

        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Optimize Your <strong>Supply Chain?</strong>
        </h2>

        <p className="text-xl text-slate-200 mb-12 max-w-3xl mx-auto leading-relaxed">
          Partner with Lynora for reliable electronic components supply, technical spare parts, and comprehensive international logistics solutions. Let's discuss how we can support your business growth.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
          <Link
            to="/contact"
            className="px-10 py-5 bg-white text-blue-600 text-lg font-bold rounded-lg hover:bg-slate-50 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-message-3-line mr-2"></i>
            Request a Quote
          </Link>
          <Link
            to="/products"
            className="px-10 py-5 bg-transparent text-white text-lg font-bold rounded-lg border-2 border-white hover:bg-white/10 hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-shopping-bag-3-line mr-2"></i>
            Browse Products
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-mail-line text-white text-4xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-2">Email Us</h3>
            <a href="mailto:contact@lynora.cz" className="text-slate-300 hover:text-white transition-colors duration-300 cursor-pointer">
              contact@lynora.cz
            </a>
          </div>

          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-time-line text-white text-4xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-2">Business Hours</h3>
            <p className="text-slate-300">Mon - Fri: 9:00 - 18:00</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
